module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/teams/teams.component.css
// module id = ./src/app/components/teams/teams.component.css
// module chunks = main